import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/pessoa/';

class NfsPessoaService {
    constructor() {
        this.idContribuinte = null;
        this.idCliente =null
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllByConttribuinteFiltro(filtro, tipoTomador) {
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'filter?idContribuinte='+this.idContribuinte+'&filtro='+filtro+'&tipoPesquisa='+tipoTomador, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    findAllByConttribuinteFiltroDaps(filtro, tipoTomador, tipoEmissao) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + 'filterDaps?idCliente='+this.idCliente+'&idContribuinte='+this.idContribuinte+'&filtro='+filtro+'&tipoPesquisa='+tipoTomador+'&tipoEmissao='+tipoEmissao, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    
    findAllByConttribuinte(idContribuinte, filtro, tipoTomador, tipoEmissao) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'filterDaps?idCliente='+this.idCliente+'&idContribuinte='+idContribuinte+'&filtro='+filtro+'&tipoPesquisa='+tipoTomador+'&tipoEmissao='+tipoEmissao, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    save(pessoa) {
        console.log(pessoa);
        return axios.post(API_URL+'create', JSON.stringify(pessoa),
        {headers: this.headers});
    }

    remove(idPessoa){
        return axios.get(API_URL + 'remove?idPessoa=' + idPessoa, {headers: this.headers});
    }

    findById(idTomadorDados){
        this.idContribuinte = LoginService.currentUserValue.contribuinte.idContribuinte;
        return axios.get(API_URL + idTomadorDados, {headers: this.headers});
    }
    
    atualizaDadosPessoa(idPessoa){
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'atualizaDadosPessoa?idCliente=' + this.idCliente
            + '&idPessoa=' + idPessoa, {headers: this.headers});
    }

    atualizaDadosPessoaValidacao(idPessoa){
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        let idTipoEconomico = LoginService.currentUserValue.configuracao.idContrTipoEconomico;
        let idTipoEventual = LoginService.currentUserValue.configuracao.idContrTipoEventual;
        return axios.get(API_URL + 'atualizaDadosPessoaValidacao?idCliente=' + this.idCliente
            + '&idPessoa=' + idPessoa+ '&idTipoEconomico=' + idTipoEconomico+ '&idTipoEventual=' + idTipoEventual, {headers: this.headers});
    }

    obterMunicipioTomador(idPessoa){
        return axios.get(API_URL + 'obterMunicipioTomador?idPessoa=' + idPessoa, {headers: this.headers});
    }

}

export default new NfsPessoaService();